import { useContext, useEffect } from 'react';

import Context from '../../Context';

interface PlansProps {
  isExpanded: boolean;
  nbPlans: number;
}

export const Plans = ({ isExpanded, nbPlans }: PlansProps) => {
  const { setIsExpanded, setNbPlans } = useContext(Context);

  setNbPlans(nbPlans);
  setIsExpanded(isExpanded);

  useEffect(() => {
    return () => {
      setNbPlans(0);
      setIsExpanded(false);
    };
  }, [setNbPlans, setIsExpanded]);

  return null;
};
